import { useTranslate } from "@pankod/refine-core";

import {
    Create,
    Drawer,
    DrawerProps,
    Form,
    FormProps,
    Input,
    // InputNumber,
    // Radio,
    Select,
    SelectProps,
    // Space,
    ButtonProps,
    // Avatar,
    // Typography,
    // Upload,
    Grid,
    // getValueFromEvent,
    useSelect,
} from "@pankod/refine-antd";

import { IOrganization } from "interfaces";

// const { Text } = Typography;


type CreateProfileProps = {
  drawerProps: DrawerProps;
  formProps: FormProps;
  saveButtonProps: ButtonProps;
};

export const CreateProfile: React.FC<CreateProfileProps> = ({
  drawerProps,
  formProps,
  saveButtonProps,
}) => {
  const t = useTranslate();
  // const apiUrl = useApiUrl();
  const breakpoint = Grid.useBreakpoint();

  // const { selectProps: categorySelectProps } = useSelect<ICategory>({
  //     resource: "categories",
  // });
  const { selectProps: orgSelectProps } = useSelect<IOrganization>({
    resource: "organizations",
  });

  const selectRole: SelectProps['options'] = [
		{ value: "agent", label: t("role.agent") },
		{ value: "manager", label: t("role.manager") },
		{ value: "admin", label: t("role.admin") },
		{ value: "client", label: t("role.client") },
	];


  // const addUser = (values: any) => {
  //   console.log(values);
  // };

  return (
    <Drawer
      {...drawerProps}
      width={breakpoint.sm ? "500px" : "100%"}
      bodyStyle={{ padding: 0 }}
      zIndex={1001}
      // closable={false}
      // visible={true}
      // onClose={() => {
      //     // drawerProps.onClose();
      // }}
      >
        {/* <Create resource="profilea" saveButtonProps={saveButtonProps}> */}
        <Create saveButtonProps={saveButtonProps}>
          {/* https://refine.dev/docs/advanced-tutorials/multi-tenancy/appwrite/#create-collections */}
          <Form
            {...formProps}
            layout="vertical"
            // onSubmitCapture={(values) => console.log(values)}
            // onFinish={(values) => {
            //   return (
            //     formProps.onFinish?.({
            //       ...values,
            //       storeId: store,
            //     })
            //   );
            // }}
            // initialValues={{
            //     isActive: true,
            // }}
          >
                    {/* <Form.Item label={t("products.fields.images.label")}>
                        <Form.Item
                            name="images"
                            valuePropName="fileList"
                            getValueFromEvent={getValueFromEvent}
                            noStyle
                            rules={[
                                {
                                    required: true,
                                },
                            ]}
                        >
                            <Upload.Dragger
                                name="file"
                                action={`${apiUrl}/media/upload`}
                                listType="picture"
                                maxCount={1}
                                accept=".png"
                            >
                                <Space direction="vertical" size={2}>
                                    <Avatar
                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            maxWidth: "256px",
                                        }}
                                        src="/images/product-default-img.png"
                                        alt="Store Location"
                                    />
                                    <Text
                                        style={{
                                            fontWeight: 800,
                                            fontSize: "16px",
                                            marginTop: "8px",
                                        }}
                                    >
                                        {t(
                                            "products.fields.images.description",
                                        )}
                                    </Text>
                                    <Text style={{ fontSize: "12px" }}>
                                        {t("products.fields.images.validation")}
                                    </Text>
                                </Space>
                            </Upload.Dragger>
                        </Form.Item>
                    </Form.Item> */}
                    <Form.Item
                        label={t("users.fields.username")}
                        name="username"
                        rules={[
                            {
                                required: true,
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    {/* <Form.Item
                        label={t("products.fields.description")}
                        name="description"
                        rules={[
                            {
                                required: true,
                            },
                        ]}
                    >
                        <Input.TextArea rows={6} />
                    </Form.Item> */}
                    {/* <Form.Item
                        label={t("products.fields.price")}
                        name="price"
                        rules={[
                            {
                                required: true,
                                type: "number",
                            },
                        ]}
                    >
                        <InputNumber
                            formatter={(value) => `$ ${value}`}
                            style={{ width: "150px" }}
                        />
                    </Form.Item> */}
                    <Form.Item
                        label={t("users.fields.role")}
                        name={["role"]}
                        rules={[
                            {
                                required: true,
                            },
                        ]}
                    >
                        <Select options={selectRole} />
                    </Form.Item>
                    <Form.Item
                        label={t("users.fields.organization")}
                        name={["organization_id"]}
                        // name={["organizations", "title"]}
                        // rules={[
                        //     {
                        //         required: true,
                        //     },
                        // ]}
                    >
                        <Select {...orgSelectProps} />
                    </Form.Item>
                    {/* <Form.Item
                        label={t("products.fields.isActive")}
                        name="isActive"
                    >
                        <Radio.Group>
                            <Radio value={true}>{t("status.enable")}</Radio>
                            <Radio value={false}>{t("status.disable")}</Radio>
                        </Radio.Group>
                    </Form.Item> */}
                </Form>
            </Create>
        </Drawer>
    );
};
